import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const UPLOAD_SINGLE_FILE_ITEM_CLASS_NAME = 'UploadSingleFileItem';
export const UPLOAD_SINGLE_FILE_ITEM_CLASS_SLOTS = ['root'] as const;

export type UploadSingleFileItemClassSlot =
	(typeof UPLOAD_SINGLE_FILE_ITEM_CLASS_SLOTS)[number];

export interface UploadSingleFileItemClasses {
	root: string;
}

export type UploadSingleFileItemClassKey = keyof UploadSingleFileItemClasses;

export const getUploadSingleFileItemUtilityClass = (slot: string) =>
	generateUtilityClass(UPLOAD_SINGLE_FILE_ITEM_CLASS_NAME, slot);

export const uploadSingleFileItemClasses: UploadSingleFileItemClasses =
	generateUtilityClasses(UPLOAD_SINGLE_FILE_ITEM_CLASS_NAME, ['root']);

export default uploadSingleFileItemClasses;
